import { html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "../../common/legal-disclaimer.js";
import "../../common/descriptor-list.js";
import "../../common/promotional-description.js";
import "../../common/offer-header.js";
import "../../common/landing-page-action.js";
import { QuoteElement } from "../../lib/quote-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let TuitionInsurance = class extends QuoteElement {
  constructor() {
    super("tuition");
  }
  render() {
    return this.quoteController.render({
      complete: () => this._renderStandardDisplay(),
      error: (e) => {
        if (e && (e == null ? void 0 : e.cause) === "StateNotAvailable") {
          return html`
            <promotional-header>
              Add Tuition Insurance
            </promotional-header>
            <div id="offer">
              <div class="error-message">
                ${e.message}
              </div>
            </div>
          `;
        }
        return html``;
      }
    });
  }
  /**
   * @ignore
   */
  get policyAttributes() {
    return {
      university_name: this.universityName,
      institution_type: this.institutionType,
      semester_start_date: this.semesterStartDate,
      semester_end_date: this.semesterEndDate,
      tuition_amount: this.tuitionAmount,
      student: {
        name: this.studentName,
        email: this.studentEmail,
        birth_date: this.studentBirthDate,
        zip_code: this.studentZipCode,
        state: this.studentState,
        country: this.studentCountry
      }
    };
  }
};
TuitionInsurance.styles = [
  QuoteElement.styles
];
__decorateClass([
  property({ attribute: "university-name" })
], TuitionInsurance.prototype, "universityName", 2);
__decorateClass([
  property({ attribute: "institution-type" })
], TuitionInsurance.prototype, "institutionType", 2);
__decorateClass([
  property({ type: Number, attribute: "tuition-amount" })
], TuitionInsurance.prototype, "tuitionAmount", 2);
__decorateClass([
  property({ attribute: "semester-start-date" })
], TuitionInsurance.prototype, "semesterStartDate", 2);
__decorateClass([
  property({ attribute: "semester-end-date" })
], TuitionInsurance.prototype, "semesterEndDate", 2);
__decorateClass([
  property({ attribute: "student-name" })
], TuitionInsurance.prototype, "studentName", 2);
__decorateClass([
  property({ attribute: "student-email" })
], TuitionInsurance.prototype, "studentEmail", 2);
__decorateClass([
  property({ attribute: "student-zip-code" })
], TuitionInsurance.prototype, "studentZipCode", 2);
__decorateClass([
  property({ attribute: "student-state" })
], TuitionInsurance.prototype, "studentState", 2);
__decorateClass([
  property({ attribute: "student-country" })
], TuitionInsurance.prototype, "studentCountry", 2);
__decorateClass([
  property({ attribute: "student-birth-date" })
], TuitionInsurance.prototype, "studentBirthDate", 2);
TuitionInsurance = __decorateClass([
  customElement("tuition-insurance")
], TuitionInsurance);
export {
  TuitionInsurance
};
